import pjson from './../package.json';

export const SERVER_URL = process.env.NODE_ENV === 'production' ? 'https://telcodox.iqmtel.net/api' : 'http://localhost:8080';
export const CLIENT_VERSION = pjson.version;
export const REACT_VERSION = pjson.dependencies.react;
